<template>
    <div class="upload_box">
        <el-form label-position="top" label-width="80px" :model="form" ref="form">

            <el-form-item label="Logo">
                <el-upload class="avatar-uploader" ref="upload" action="" :auto-upload="true" name="image7"
                    :http-request="upload" :before-upload="beforeUploadFile" :on-change="handleChange"
                    :file-list='fileList' :on-remove="handleRemove">
                    <el-button size="small">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">jpg格式,上传的图片大小请按设计稿上的尺寸定义</div>
                </el-upload>
                <div>
                    <img :src="form.logo" class="img">
                </div>
            </el-form-item>
            <el-form-item label="微信关注二维码">
                <el-upload class="avatar-uploader" ref="upload" action="" :auto-upload="true" name="image7"
                    :http-request="upload2" :before-upload="beforeUploadFile" :on-change="handleChange2"
                    :file-list='fileList2' :on-remove="handleRemove2">
                    <el-button size="small">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">jpg格式,上传的图片大小请按设计稿上的尺寸定义</div>
                </el-upload>
                <div>
                    <img :src="form.wechat" class="img">
                </div>
            </el-form-item>
            <el-form-item label="首页大Banner">
                <el-upload class="avatar-uploader" ref="upload" action="" :auto-upload="true" name="image7"
                    :http-request="upload3" :before-upload="beforeUploadFile" :on-change="handleChange3"
                    :file-list='fileList3' :on-remove="handleRemove3">
                    <el-button size="small">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">jpg格式,上传的图片大小请按设计稿上的尺寸定义</div>
                </el-upload>
                <div>
                    <img :src="form.banner" class="img">
                </div>
            </el-form-item>
            <el-button class="btn" type="primary" @click="Save">保存图片</el-button>

        </el-form>
    </div>
</template>

<script>
    import local from '../utils/local'
    import axios from 'axios'
    import {
        sends,
        getinfo
    } from '../api/api'
    export default {
        data() {
            return {
                form: {
                    logo: '',
                    wechat: '',
                    banner: ''
                },
                admin_id: local.get('admin_id'),
                fileList: [],
                fileList2: [],
                fileList3: [],
            }
        },
        methods: {
            beforeUploadFile(file) {
                const isJPG = file.type === "image/jpeg";
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error("上传图片只能是 JPG格式!");
                }
                if (!isLt2M) {
                    this.$message.error("上传图片大小不能超过 2MB!");
                }
                return (isJPG && isLt2M);
            },

            upload(file) {
                var formD = new FormData();
                formD.append('file', file.file);
                axios.post('https://api2.home.didigo.es/admin/admin/photo', formD).then(res => {
                    if (res.data.status == 200) {
                        this.form.logo = res.data.data.url;

                    }
                })

            },
            handleRemove(file, fileList) {
                this.fileList.shift()
                this.form.logo = '';

            },
            upload2(file) {
                var formD = new FormData();
                formD.append('file', file.file);
                axios.post('https://api2.home.didigo.es/admin/admin/photo', formD).then(res => {
                    if (res.data.status == 200) {
                        this.form.wechat = res.data.data.url;

                    }
                })

            },
            handleRemove2(file, fileList) {
                this.fileList.shift()
                this.form.wechat = '';

            },
            upload3(file) {
                var formD = new FormData();
                formD.append('file', file.file);
                axios.post('https://api2.home.didigo.es/admin/admin/photo', formD).then(res => {
                    if (res.data.status == 200) {
                        this.form.banner = res.data.data.url;

                    }
                })

            },
            handleRemove3(file, fileList) {
                this.fileList.shift()
                this.form.banner = '';

            },
            
            Save() {

                sends(this.admin_id, this.form.logo, this.form.wechat, this.form.banner).then(res => {
                    if (res.data.status == 200) {
                        this.$message({
                            type: 'success',
                            message: '保存成功'
                        })
                        this.getInfo()
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            getInfo() {
                getinfo(this.admin_id).then(res => {
                    console.log(res)
                    if (res.data.status == 200) {
                        Object.assign(this.form, res.data.data[0])
                    }
                })
            },
            handleChange(file, fileList) {
                if (fileList.length > 0) {
                    this.fileList = [fileList[fileList.length - 1]]; // 这一步，是 展示最后一次选择的csv文件
                }

            },
            handleChange2(file, fileList) {
                if (fileList.length > 0) {
                    this.fileList2 = [fileList[fileList.length - 1]]; // 这一步，是 展示最后一次选择的csv文件
                }

            },
            handleChange3(file, fileList) {
                if (fileList.length > 0) {
                    this.fileList3 = [fileList[fileList.length - 1]]; // 这一步，是 展示最后一次选择的csv文件
                }

            },
        },
        created() {
            this.getInfo()
        }
    }
</script>

<style lang="less" scoped>
    .upload_box {
        padding: 0 50px;

        .el-form-item {
            margin: 0;

            .el-form--label-top .el-form-item__label {
                padding: 0 !important;
            }

            .el-input {
                width: 800px;
            }

            .el-upload__tip {
                margin: 0;
            }

            .img {
                width: 110px;
            }

        }

        .btn {
            margin-top: 20px;
        }
    }
</style>